var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value ? _c("user-image", { attrs: { user: _vm.value } }) : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }